module.exports = __webpack_public_path__ + "assets/img/main3.c36e2af8.png";